import { IconExclamationTriangleFilled } from '@iwoca/icons';
import { Trans } from '@lingui/react/macro';
import styles from './DocumentRequirement.module.css';

export const Required = () => {
  return (
    <span className={styles.required}>
      <IconExclamationTriangleFilled
        className={styles.requiredIcon}
        height={20}
        width={20}
      />
      <Trans>Required</Trans>
    </span>
  );
};
